// FiltersBar.jsx
import React from "react";
import FilterDropdown from "../../dropdowns/filter-dropdown";
import { MaterialMenu, ColorMenu,MaterialMenuTwo } from "../../dropdowns/menus";
import { SelectedFilters } from "../../dropdowns/selected-filters";


const INDUSTRY_OPTIONS = [
    { value: "residential", label: "Residential" },
    { value: "commercial", label: "Commercial" },
    { value: "senior-living", label: "Senior Living" }
];

const PRICE_OPTIONS = [
    { value: "300", label: "Greater Than $300" },

];

const FEATURES_OPTIONS = [
    { value: "leather", label: "Available in Leather" },
    { value: "commercial_grad", label: "Commercial-Grade" }
];


const PRODUCTS_OPTIONS = [
    { value: "arm_chair", label: "Arm Chair" },
    { value: "bar_cabinet", label: "Bar Cabinet" },
    { value: "bed", label: "Bed" },
    { value: "chest", label: "Chest" },
    { value: "cocktail_table", label: "Cocktail Table" },
    { value: "console", label: "Console" },
    { value: "credenza", label: "Credenza" },
    { value: "dining_table", label: "Dining Table" },
    { value: "dresser", label: "Dresser" },
    { value: "end_table", label: "End Table" },
    { value: "nightstand", label: "Nightstand" },
    { value: "side_chair", label: "Side Chair" }
];

const WIDTHS_OPTIONS = [
    { value: "0-20", label: "0-20 inches" },
    { value: "20-50", label: "20-50 inches" }
];

const QUICK_OPTIONS = [
    { value: "new", label: "New Items" },
    { value: "inStock", label: "In Stock" }
];

const HEIGHTS_OPTIONS = [
    { value: "0-20", label: "0-20 inches" },
    { value: "20-50", label: "20-50 inches" }
];

const DEPTHS_OPTIONS = [
    { value: "0-20", label: "0-20 inches" },
    { value: "20-50", label: "20-50 inches" }
];

const ARM_HEIGHTS_OPTIONS = [
    { value: "0-20", label: "0-20 inches" },
    { value: "20-40", label: "20-40 inches" }
];

class CollectionFiltersBar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            price: [],
            industry: [], // array of values
            features: [], // array of values
            quick: [],
            products:[],
            widths:[],
            heights:[],
            depths:[],
            armHeights:[],
            showMoreFilters:false

            // later: price, height, etc.
        };
    }

    toggleValueOLD = (group, value) => {
        this.setState((prev) => {
            const current = prev[group] || [];
            const exists = current.indexOf(value) !== -1;
            return {
                ...prev,
                [group]: exists
                    ? current.filter((v) => v !== value)
                    : current.concat(value),
            };
        });
    };

    toggleValue = (group, value) => {
        this.setState((prev) => {
            const current = prev[group] || [];
            const exists = current.indexOf(value) !== -1;

            const updatedGroup = exists
                ? current.filter((v) => v !== value)
                : current.concat(value);

            const nextState = {
                ...prev,
                [group]: updatedGroup,
            };

            if (typeof this.props.onFiltersChange === "function") {
                // pass the full filters object up to the parent
                this.props.onFiltersChange(nextState);
            }

            return nextState;
        });
    };

    clearGroup = (group) => {
        this.setState((prev) => ({ ...prev, [group]: [] }));
    };

    clearAll = () => {
        this.setState({
            price: [],
            industry: [], // array of values
            features: [], // array of values
            quick: [],
            products: [],
            widths: [],
            heights: [],
            depths: [],
            armHeights: []
        },()=>{this.props.onFiltersChange(this.state);} );
    };

    getSelectedItems() {
        const { price, industry, features, quick, products,heights,widths,depths,armHeights } = this.state;
        const chips = [];

        PRICE_OPTIONS.forEach((opt) => {
            if (price.indexOf(opt.value) !== -1) {
                chips.push({
                    id: `price:${opt.value}`,
                    group: "price",
                    value: opt.value,
                    label: `Price: ${opt.label}`,
                });
            }
        });

        INDUSTRY_OPTIONS.forEach((opt) => {
            if (industry.indexOf(opt.value) !== -1) {
                chips.push({
                    id: `industry:${opt.value}`,
                    group: "industry",
                    value: opt.value,
                    label: `Industry: ${opt.label}`,
                });
            }
        });

        FEATURES_OPTIONS.forEach((opt) => {
            if (features.indexOf(opt.value) !== -1) {
                chips.push({
                    id: `features:${opt.value}`,
                    group: "features",
                    value: opt.value,
                    label: `Features: ${opt.label}`,
                });
            }
        });

        QUICK_OPTIONS.forEach((opt) => {
            if (quick.indexOf(opt.value) !== -1) {
                chips.push({
                    id: `quick:${opt.value}`,
                    group: "quick",
                    value: opt.value,
                    label: `Quick: ${opt.label}`,
                });
            }
        });
        PRODUCTS_OPTIONS.forEach((opt) => {
            if (products.indexOf(opt.value) !== -1) {
                chips.push({
                    id: `product:${opt.value}`,
                    group: "products",
                    value: opt.value,
                    label: `Product Type: ${opt.label}`,
                });
            }
        });
        
        WIDTHS_OPTIONS.forEach((opt) => {
            if (widths.indexOf(opt.value) !== -1) {
                chips.push({
                    id: `width:${opt.value}`,
                    group: "widths",
                    value: opt.value,
                    label: `Width: ${opt.label}`,
                });
            }
        });
        HEIGHTS_OPTIONS.forEach((opt) => {
            if (heights.indexOf(opt.value) !== -1) {
                chips.push({
                    id: `height:${opt.value}`,
                    group: "heights",
                    value: opt.value,
                    label: `Height: ${opt.label}`,
                });
            }
        });
        DEPTHS_OPTIONS.forEach((opt) => {
            if (depths.indexOf(opt.value) !== -1) {
                chips.push({
                    id: `depth:${opt.value}`,
                    group: "depths",
                    value: opt.value,
                    label: `Depth: ${opt.label}`,
                });
            }
        });
        ARM_HEIGHTS_OPTIONS.forEach((opt) => {
            if (armHeights.indexOf(opt.value) !== -1) {
                chips.push({
                    id: `arm_height:${opt.value}`,
                    group: "armHeights",
                    value: opt.value,
                    label: `Arm Height: ${opt.label}`,
                });
            }
        });

        return chips;
    }

    handleRemoveChip = (chip) => {
        this.toggleValue(chip.group, chip.value);
    };

    onMoreLessFilters = () => {
        this.setState((prev) => ({
            showMoreFilters: !prev.showMoreFilters
        }));
    }

    render() {
        const { features, quick, products,heights,widths,depths,armHeights } = this.state;
        const chips = this.getSelectedItems();
        let state=this.state;
        let moreLessLabel=state.showMoreFilters?"Less Filters":"More Filters";
        let moreLessSymbol=state.showMoreFilters?"-":"+";
        let moreLessClass=state.showMoreFilters?"ff-filter-minus":"ff-filter-plus";
        return (
            <div>
                {/* Top filter bar */}
                <div className="ff-filter-bar">
                    <FilterDropdown label="Industry">
                        {({ close }) => (
                            <MaterialMenu
                                options={INDUSTRY_OPTIONS}
                                selectedValues={industry}
                                onToggle={(value) => this.toggleValue("industry", value)}
                            />
                        )}
                    </FilterDropdown>
                    <FilterDropdown label="Price">
                        {({ close }) => (
                            <MaterialMenu
                                options={PRICE_OPTIONS}
                                selectedValues={price}
                                onToggle={(value) => this.toggleValue("price", value)}
                            />
                        )}
                    </FilterDropdown>
                    <FilterDropdown label="Features">
                        {({ close }) => (
                            <MaterialMenu
                                options={FEATURES_OPTIONS}
                                selectedValues={features}
                                onToggle={(value) => this.toggleValue("features", value)}
                            />
                        )}
                    </FilterDropdown>

                    <FilterDropdown label="Quick">
                        {({ close }) => (
                            <MaterialMenu
                                options={QUICK_OPTIONS}
                                selectedValues={quick}
                                onToggle={(value) => this.toggleValue("quick", value)}
                            />
                        )}
                    </FilterDropdown>
                    <FilterDropdown label="Products">
                        {({ close }) => (
                            <MaterialMenuTwo
                                options={PRODUCTS_OPTIONS}
                                selectedValues={products}
                                onToggle={(value) => this.toggleValue("products", value)}
                            />
                        )}
                    </FilterDropdown>
                    {state.showMoreFilters && (
                        <>
                            <FilterDropdown label="Widths">
                                {({ close }) => (
                                    <MaterialMenu
                                        options={WIDTHS_OPTIONS}
                                        selectedValues={widths}
                                        onToggle={(value) => this.toggleValue("widths", value)}
                                    />
                                )}
                            </FilterDropdown>
                            <FilterDropdown label="Heights">
                                {({ close }) => (
                                    <MaterialMenu
                                        options={HEIGHTS_OPTIONS}
                                        selectedValues={heights}
                                        onToggle={(value) => this.toggleValue("heights", value)}
                                    />
                                )}
                            </FilterDropdown>
                            <FilterDropdown label="Depths">
                                {({ close }) => (
                                    <MaterialMenu
                                        options={DEPTHS_OPTIONS}
                                        selectedValues={depths}
                                        onToggle={(value) => this.toggleValue("depths", value)}
                                    />
                                )}
                            </FilterDropdown>
                            <FilterDropdown label="Arm Heights">
                                {({ close }) => (
                                    <MaterialMenu
                                        options={ARM_HEIGHTS_OPTIONS}
                                        selectedValues={armHeights}
                                        onToggle={(value) => this.toggleValue("armHeights", value)}
                                    />
                                )}
                            </FilterDropdown>
                        </>
                    )}
                    <div className="ff-more-filters-button" onClick={this.onMoreLessFilters}>
                        <span className="ff-more-filters-label">{moreLessLabel}</span><span className={moreLessClass}>{moreLessSymbol}</span>
                    </div>
                   
                </div>

                {/* Selected filters row */}
                <SelectedFilters
                    items={chips}
                    onRemove={this.handleRemoveChip}
                    onClearAll={this.clearAll}
                />
            </div>
        );
    }
}

export default CollectionFiltersBar;
